"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventTooling = void 0;
var react_1 = __importStar(require("react"));
var create_event_system_1 = require("./create-event-system");
function createEventTooling() {
    var EventsContext = (0, react_1.createContext)(null);
    function useEvents() {
        var events = (0, react_1.useContext)(EventsContext);
        if (events === null) {
            throw new Error('useEvents must be used within EventsProvider');
        }
        return events;
    }
    function EventsProvider(_a) {
        var _b;
        var children = _a.children, _c = _a.subscriptions, subscriptions = _c === void 0 ? [] : _c;
        var eventSystem = (0, react_1.useRef)();
        var onExit = (0, react_1.useRef)();
        var currentSubscriptions = (0, react_1.useRef)(subscriptions);
        if (!eventSystem.current) {
            eventSystem.current = (0, create_event_system_1.createEventSystem)();
            onExit.current = eventSystem.current.addSubscriptions(subscriptions);
        }
        if (currentSubscriptions.current !== subscriptions) {
            (_b = onExit.current) === null || _b === void 0 ? void 0 : _b.call(onExit);
            eventSystem.current = (0, create_event_system_1.createEventSystem)();
            onExit.current = eventSystem.current.addSubscriptions(subscriptions);
        }
        (0, react_1.useEffect)(function () { return onExit.current; }, []);
        return (react_1.default.createElement(EventsContext.Provider, { value: eventSystem.current }, children));
    }
    function withEvents(WrappedComponent) {
        return function (props) {
            var eventSystem = useEvents();
            return react_1.default.createElement(WrappedComponent, __assign({}, props, { events: eventSystem }));
        };
    }
    return { EventsProvider: EventsProvider, useEvents: useEvents, withEvents: withEvents };
}
exports.createEventTooling = createEventTooling;
